import ImportExportHistory from '@assets/loadables/ImportExportHistory';

export default [
  {
    path: '/import-export-history',
    component: ImportExportHistory,
    scope: 'import_export_history.view'
  }
];
